import { NetworkActionPrefix, ActionType } from '../utils/constants';
import { UserApi } from 'for-straction-service-api'
import { networkAPIAction } from '../utils/actionCreatorsFactory';

const welcomeGuide = {
    finishWelcomeGuideStep: (stepIdentifier) => ({ type: ActionType.FINISH_WELCOME_GUIDE_STEP, stepIdentifier }),
    sendMobileAppLinkViaSms: networkAPIAction.bind(this, new UserApi(), 'userSendMobileAppLinkWithSmsGet', NetworkActionPrefix.SEND_MOBILE_APP_LINK_VIA_SMS_PREFIX, ['phone'])
};

export default welcomeGuide;